import hres94uLabels from 'assets/labels/hres94u'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres94uLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number(),
        dteyear: moment().format('DD/MM/YYYY'),
        numclseq: faker.lorem.word(),
        desc_codcours: faker.name.findName(),
        desc_codtparg: faker.name.findName(),
        status: faker.lorem.words(),
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remark: faker.lorem.words(),
        desc_codempap: faker.name.findName()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codinput: faker.lorem.word(),
      desc_codinput: faker.name.findName(),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      dteyear: moment().format('YYYY'),
      numclseq: faker.random.number(),
      codcours: faker.lorem.word(),
      desc_codcours: faker.lorem.word(),
      dtetrst: moment().format('DD/MM/YYYY'),
      dtetren: moment().format('DD/MM/YYYY'),
      qtytrmin: faker.random.number(),
      desc_codinsts: faker.lorem.word(),
      desc_codhotel: faker.lorem.word(),
      desc_codinst: faker.name.findName(),
      amtemp: faker.random.number(),
      desreq: faker.lorem.words()
    }

    return {
      tab1: mockTab1
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres94u/mocker.js